module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button"
  }, [_c('button', {
    class: _vm.className,
    on: {
      "click": _vm.buttonClick
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dee14dfc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bouton/Bouton.vue
// module id = 29
// module chunks = 1